<template>
  <va-card  class="flex mb-4">
    <va-card-title ref="titleRef" style="height: 30px;padding:5px;padding-left:20px ">社区管理</va-card-title>
    <va-card-content>
      <div>
        <div class="formHead">
          <vxe-form :data="toolbar.formData">

            <vxe-form-item title="关键字" field="searchKey" :item-render="{}"
              :title-prefix="{icon: 'fa fa-info-circle',message:'输入标题、创建人姓名、创建人别名'}">
              <template #default="{ data }">
                <vxe-input clearable v-model="data.searchKey" placeholder="输入标题、创建人姓名、创建人别名"></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item title="板块" field="searchStatus" :item-render="{}">
              <template #default="{ data }">
                <vxe-select v-model="data.searchStatus" placeholder="请选择">
                  <vxe-option :value="item.ID" :label="item.Name" v-for="(item,index) in plateOption" :key="index"></vxe-option>

                </vxe-select>
              </template>
            </vxe-form-item>
            <vxe-form-item>
              <template #default>
                <vxe-button status="primary" @click="findData" @keyup.enter="findData">查询</vxe-button>
                <vxe-button @click="clear">重置</vxe-button>
                <!-- <vxe-button @click="exportDataEvent">导出</vxe-button>
                  <vxe-button v-if="isShowEditRow" @click="importDataEvent">导入</vxe-button> -->
              </template>
            </vxe-form-item>

            <vxe-form-item>
              <vxe-button status="success" @click="getSelectEvent1('class')">设置分类</vxe-button>
              <vxe-button status="success" @click="getSelectEvent1('plate')">移动板块</vxe-button>
              <vxe-button status="success" @click="getSelectEvent1(1)">禁止回复</vxe-button>
              <vxe-button status="success" @click="getSelectEvent1(2)">设为精华</vxe-button>
              <vxe-button status="success" @click="getSelectEvent1(3)">设置置顶</vxe-button>
              <vxe-button status="success" @click="getSelectEvent1(4)">设置可见</vxe-button>
            </vxe-form-item>

          </vxe-form>
        </div>
        <!-- <va-inner-loading :loading="isLoading" style="width: 100%;"  color="primary"> -->
        <div style="overflow: hidden;height: 100%">
          <vxe-table
            stripe
            class="mytable-scrollbar"
            :data="tableData"
            :height="tableHeight"
            show-overflow
            :row-config="{height: 36,isHover: true,isCurrent:true}"
            ref="xTable1"
            :loading="isLoading"
          >
            <vxe-column type="checkbox" width="30" fixed="left"></vxe-column>
            <vxe-column type="seq" field="Id" title="序号" width="50" align="center" fixed="left"></vxe-column>

            <vxe-column title="编辑" width="50" :visible="isShowEditRow">
              <template #default="{ row }">
                <vxe-button type="text" icon="fa fa-edit" @click="editEvent(row)"></vxe-button>
              </template>
            </vxe-column>
            <vxe-column title="删除" width="50" :visible="isShowEditRow">
              <template #default="{ row }">
                <vxe-button type="text" icon="fa fa-trash-o" @click="removeReqRowEvent(row)"></vxe-button>
              </template>
            </vxe-column>

            <vxe-column title="标题" width="150" field="Title" show-overflow resizable sortable>

            </vxe-column>
            <vxe-column field="CreatorName" width="90" title="创建人" resizable show-overflow></vxe-column>
            <vxe-column field="SectionName" title="板块" width="110"  show-overflow></vxe-column>
            <vxe-column field="CateName" title="分类" width="90"  show-overflow></vxe-column>
            <vxe-column field="CreateTime" title="创建日期" width="120" sortable :formatter="formatTime"></vxe-column>
            <vxe-column title="禁止回复" width="100" sortable align="center">
              <template #default="{ row }">
                <div>
                  {{row.IsForbidReply == 0 ? '否' : '是' }}
                </div>
              </template>
            </vxe-column>
            <vxe-column title="是否精华" width="100" sortable align="center">
              <template #default="{ row }">
                <div>
                  {{row.IsElite == 0 ? '否' : '是' }}
                </div>
              </template>
            </vxe-column>
            <vxe-column title="是否可见" width="100" sortable align="center">
              <template #default="{ row }">
                <div>
                  {{row.IsShow == 0 ? '否' : '是' }}
                </div>
              </template>
            </vxe-column>
            <vxe-column title="是否置顶" width="100" sortable align="center">
              <template #default="{ row }">
                <div>
                  {{row.IsTop == 0 ? '否' : '是' }}
                </div>
              </template>
            </vxe-column>
          </vxe-table>
        </div>
        <!-- </va-inner-loading> -->
        <div>
          <vxe-pager
            background
            v-model:current-page="tablePager.currentPage"
            v-model:page-size="tablePager.pageSize"
            :total="tablePager.totalResult"
            @page-change="handlePageChange"
            :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
          </vxe-pager>
        </div>
      </div>
      <vxe-modal title="选择分类" v-model="iShowSelectClass" width="300">
        <template #default>
          <div style="margin-right:20px;    text-align: center;">
            <!-- <h2>筛选分类：</h2> -->
            <a-cascader :show-search="{ selectFilter }" v-model:value="classValue" @change="handleChange" style="width:100%;margin-bottom:20px;text-align:left;" placeholder="请选择分类" notFoundContent="暂无数据" :options="classOptions" change-on-select :fieldNames="{ label: 'Name', value: 'ID', children: 'Children' }" />
            <vxe-button @click="setClass" icon="fa fa-save" status="success">
              保存
            </vxe-button>
          </div>
        </template>
      </vxe-modal>
      <vxe-modal :title="setStateTit" v-model="isShowSetState" width="300">
        <template #default>
          <div style="margin-right:20px;text-align: center;">
            <vxe-select v-model="setStateValue" placeholder="请选择"  style="margin-bottom:20px;">
              <vxe-option value="1" label="是"></vxe-option>
              <vxe-option value="0" label="否"></vxe-option>
            </vxe-select>
            <vxe-button @click="updateArticleState" icon="fa fa-save" status="success">
              保存
            </vxe-button>
          </div>
        </template>
      </vxe-modal>
      <vxe-modal title="移动板块" v-model="iShowSelectPlate" width="330" height="300" resize="true">
        <template #default>
          <div style="margin-right:20px;    text-align: center;">
            <vxe-select v-model="plateValue" placeholder="请选择" style="margin-bottom:20px;">
              <vxe-option :value="item.ID" :label="item.Name" v-for="(item,index) in plateOption2" :key="index"></vxe-option>

            </vxe-select>
            <vxe-button @click="setPlate" icon="fa fa-save" status="success" style="margin-left: 10px">
              保存
            </vxe-button>
          </div>
        </template>
      </vxe-modal>
      <vxe-modal
        v-model="stateisShow"
        :title="stateTitle"
        width="840" height="600"
        @close="closeReqEvent"
        show-zoom resize remember>
        <template #default>
          <chindArticleCompile @amendArticle="closeReqEvent" :searcharticle="compileId"></chindArticleCompile>
        </template>
      </vxe-modal>
      <vxe-modal
        v-model="formInput.isShow"
        :title="formTitle"
        width="840" height="600"
        @close="closeReqEvent"

        className="xmodel"
        show-zoom resize remember>
        <template #default>
          <chindArticleCompile @amendArticle="closeReqEvent" :searcharticle="compileId"></chindArticleCompile>
        </template>
      </vxe-modal>
    </va-card-content>
  </va-card>

</template>

<script>
import Qs from 'qs'
import {reactive, ref,defineComponent} from 'vue'
import {VXETable, VxeTableInstance, VxeTablePropTypes,VxeTableEvents} from 'vxe-table'
import XEUtils from 'xe-utils'
import chindArticleCompile from '../myPlug/chindArticleCompile.vue'//修改编辑

export default defineComponent({
  name: "RequireList",
  components: {
    // MyAuditLine,
    chindArticleCompile
  },
  data() {
    const selectFilter = (inputValue, path) => {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    };
    // const pageHeight = window.innerHeight-78+'px';//屏幕高度减去导航栏和内补白
    const pageHeight = window.innerHeight-(65+48+245)+'px'
    const tablePager = reactive({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0
    })
    const toolbar = reactive({
      loading: false,
      formData: {
        searchKey: '',
        searchStatus: ''
      }
    })
    const formInput = reactive({
      isShow: false,
      plateOption:[],
      plateOption2:[],
      formData: {
        Id: '',
        processName: '',
        processDesc: '',
        bussName: '',

      },
      formRules: {
        requireNo: [
          {required: false, message: '需求编号不能为空'},
        ],
        processName: [
          {required: true, message: '请输入流程名称'}
        ],

      },
      stepsData: []
    })

    return {
      stateParams:'',
      setStateValue:'',
      stateList:[{zhName:'设置禁止回复',enName:'IsForbidReply'},{zhName:'设为精华',enName:'IsElite'},{zhName:'设置置顶',enName:'IsTop'},{zhName:'设置可见',enName:'IsShow'}],
      isShowSetState:false,
      setStateTit:'',
      stateisShow:false,
      stateTitle:'',
      compileId:'',//编辑的id
      plateValue:'',
      iShowSelectPlate:false,
      selectFilter,
      classValue:[],
      iShowSelectClass:false,
      classOptions:[],
      pageHeight,
      tableData: null,
      tablePager,
      toolbar,
      formInput,
      formDisable: true,
      dtAudit: null,
      isShowEditRow: false,
      isShowSaveBtn: false,

      formTitle: '查看需求',
      isLoading:false,
      tableHeight: 0
    }
  },
  methods: {
    //设置禁止回复、设为精华、设置置顶、设置可见
    updateArticleState(paramItem){
      const $table = this.$refs.xTable1
      const selectRecords = $table.getCheckboxRecords()

      const params = {
          "ArticleID":selectRecords[0].ID,//帖子ID
          "State":this.setStateValue,//状态 1 是 0否
          "Type":this.stateParams//1 禁止回复，2 精华，3 置顶，4 可见
      };
      console.log(params)
      this.$api.formsAPI.updateArticleState(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          VXETable.modal.message({zIndex:2000,content: `${this.setStateTit}成功！`, status: 'success'});
          this.isShowSetState = false;
          this.stateParams = '';
          this.findData()
        })
        .catch(error => {
          console.log(error);
        })
    },

    //编辑帖子
    closeReqEvent() {
      this.formInput.isShow = false;
      this.findData()
    },
    //选择多选
    handleChange(v){
      console.log(v)
    },

    //设置板块
    setPlate(){
      const $table = this.$refs.xTable1
      const selectRecords = $table.getCheckboxRecords()
      if(this.plateValue == ''){
        VXETable.modal.message({zIndex:2000,content: '请选择板块！', status: 'info'});
        return;
      }
      const params = {
          "ArticleID":selectRecords[0].ID,
          "SectionID":this.plateValue
      };
      this.$api.formsAPI.updateArticleSection(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          VXETable.modal.message({zIndex:2000,content: '移动板块成功！', status: 'success'});
          this.iShowSelectPlate = false;
          this.plateValue = '';
          this.findData()
        })
        .catch(error => {
          console.log(error);
        })
    },

    //设置分类
    setClass(){
      const $table = this.$refs.xTable1
      const selectRecords = $table.getCheckboxRecords()
      const fenLeiVal = this.classValue;
      if(fenLeiVal.length == 0){
        VXETable.modal.message({zIndex:2000,content: '请选择分类！', status: 'info'});
        return;
      }
      // let classArr = [];//中文数组
      // const flidx = fenLeiVal[0]-1;
      // if(fenLeiVal.length > 1){
      //   //-1就是下标号
      //   const chindfl = this.classOptions[flidx]['Children'].filter(item =>{
      //     return item.ID == fenLeiVal[1];
      //   })
      //   classArr = [this.classOptions[flidx].Name,chindfl[0].Name]
      // }else{
      //   classArr = this.classOptions[flidx].Name;
      // }
      // console.log(typeof classArr)
      console.log(fenLeiVal.length)
      console.log(fenLeiVal.length > 1 ? fenLeiVal.join(',') : fenLeiVal[0])
      const params = {
          "ArticleID":selectRecords[0].ID,
          "CateID":fenLeiVal == undefined ? '' : fenLeiVal[fenLeiVal.length-1],
          "CateLabel":fenLeiVal.length > 1 ? fenLeiVal.join(',') : fenLeiVal[0]
          // "CateLabel":typeof classArr != 'string' ? classArr.join(',') : classArr
      };
      this.$api.formsAPI.updateArticleCate(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          VXETable.modal.message({zIndex:2000,content: '设置分类成功！', status: 'success'});
          this.iShowSelectClass = false;
          this.classValue = []
           this.findData()
        })
        .catch(error => {
          console.log(error);
        })
    },

    //显示设置
    getSelectEvent1(params){
      const $table = this.$refs.xTable1
      const selectRecords = $table.getCheckboxRecords()
      if(selectRecords.length > 1 || selectRecords.length == 0){
        VXETable.modal.message({zIndex:2000,content: '请选择一行数据', status: 'info'});
        return;
      }
      //设置分类
      if(params == 'class'){
        this.iShowSelectClass = true;
      //移动板块
      }else if(params == 'plate'){
        this.iShowSelectPlate = true;
      //设置禁止回复、设为精华、设置置顶、设置可见
      }else{

        this.isShowSetState = true;
        this.setStateValue = selectRecords[0][`${this.stateList[params-1].enName}`]//设置默认键名
        this.setStateTit = this.stateList[params-1].zhName//设置标题
        // console.log(this.stateList[params-1].enName)
        // this.updateArticleState(params)
        this.stateParams = params;
      }

    },
    //获取分类
    getForumGategory(){
      const params = {
          "Name":""
      };
      this.$api.formsAPI.getForumGategory(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          this.classOptions = res.data.Data;

         this.$store.commit('updateClassOptions', res.data.Data);
        })
        .catch(error => {
          console.log(error);
        })
    },
    selectUser(type) {
      this.selectType = type;
      this.toolbar.formData.searchKey = '';

    },

    launchToast(toastMsg) {
      this.$vaToast.init({
        message: toastMsg,
        iconClass: this.toastIcon,
        position: this.toastPosition,
        duration: Number(this.toastDuration),
        fullWidth: this.isToastFullWidth,
      })
    },
    editEvent(row) {

      console.log(row)
      this.compileId = row.ID;
      this.isShowSaveBtn = true;
      this.formTitle = '修改帖子';
      this.formInput.isShow = true;
    },
    //删除帖子
    async removeReqRowEvent(row) {

      const type = await VXETable.modal.confirm('您确定要删除该数据?')
      const $grid = this.$refs.xTable1
      if (type === 'confirm') {
        let params = {
            "ArticleID":row.ID,//帖子ID
            "UserID": this.$store.state.userID, //用户UID
          }

        this.$api.formsAPI.delForumArticle(Qs.stringify(params)).then(res => {
          if (res.data.Success == false) {
              VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
              return;
            }
            VXETable.modal.message({zIndex:2000,content: "删除成功", status: 'success'});
            // $grid.remove(row);
            this.delUserCredit(row.ID)
            this.findData()

          }).catch(error => {
          console.log(error);
        })
      }
    },
    //减积分
    delUserCredit(postsId) {
        let params = {
            "ArticleID":postsId,//帖子ID
            "UserID": this.$store.state.userID, //用户UID
            "Type":2
          }
        this.$api.formsAPI.delUserCredit(Qs.stringify(params)).then(res => {
          if (res.data.Success == false) {
              VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
              return;
            }
          }).catch(error => {
          console.log(error);
        })
    },
    calTableHeight(rowsLength) {
      let minHeight = window.innerHeight - (65 + 28 + 198);
      let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36+22;
      this.tableHeight = Math.max(minHeight, calHeight);
    },
    findData() {
      this.isLoading = true;
      let params = {
        "SectionID":this.toolbar.formData.searchStatus,//版块ID
        "Label":this.tagValue == undefined ? '' : this.tagValue.join(','), //标签ID，用‘,’隔开
        "KeyWord": this.toolbar.formData.searchKey, //查询关键字，标题或内容
        "Category":this.classValue  == undefined ? '' : this.classValue.join(','), //类别ID
        "IsElite": this.checked ? 1 : '', //1 精华；空或其他，全部
        "Creator": '', //发布人UID
        "TimeSpan": "", //0 今天 1 三天内 2 一周内 3 一月内 4 半年内
        "Order": "", //0 最近更新 1 最新发布 2 点赞数 3 回复数
        "currentPage":this.tablePager.currentPage, //当前页
        "pageSize":this.tablePager.pageSize//页大小
         },resData;
      this.$api.formsAPI.getForumArticle(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          this.tableData = res.data.Data.dataTable;
          console.log(res.data.Data)
          // this.$store.commit('updateSearchData','');
          this.tablePager.totalResult = res.data.Data.totalResult;
          this.tablePager.currentPage = res.data.Data.currentPage;
          this.tablePager.pageSize = res.data.Data.pageSize;
          this.isLoading = false;
          this.tableHeight = this.$calTableHeight(res.data.Data.dataTable.length);
        })
        .catch(error => {
          console.log(error);
        })
    },
    handlePageChange() {
      this.findData();
    },
    clear() {
      this.toolbar.formData.searchKey = '';
      this.toolbar.formData.searchStatus = '';
    },
    keydown(e) {
      if (e.keyCode === 13) {
        this.findData();
      }
    },
    exportDataEvent() {
      const $table = this.$refs.xTable1;
      $table.exportData({type: 'csv'})
    },
    async importDataEvent() {
      const {files} = await VXETable.readFile(false)
      if (files == null || files.length == 0) {
        return;
      }
      const data = new FormData();
      data.append('file', files[0]);
      this.$api.requireManageAPI.importRequires(data)
        .then(res2 => {
          if (res2.data.Success == false) {
            VXETable.modal.message({zIndex:2000,content: res2.data.Message, status: 'error'});
            return;
          }
          VXETable.modal.message({zIndex:2000,content: '导入成功', status: 'success'});

          this.findData();
        })
        .catch(error2 => {
          VXETable.modal.alert({content: error2, status: 'error'});
          console.log(error2);
        });
    },
    formatTime({cellValue, row, column}) {
      return XEUtils.toDateString(cellValue, 'yyyy-MM-dd')
    },

    isAdmin() {
      return this.$store.state.isAdmin === '1';
    },
    //获取板块
    getForumSection(paramData){
      let resData,totalArticle = 0,totalReply = 0;
      const params = {
          "Name": "",
      };
      this.$api.formsAPI.getForumSection(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          let arr = [{value: '',Name: '全部板块',IsTab:'',ID:''}];
            resData = res.data.Data;
            resData.map((item,index) =>{
              // console.log(item.ArticleCount)
              totalArticle+=Number(item.ArticleCount);
              totalReply+=Number(item.ReplyCount);
            })

          this.plateOption2 = resData;
          this.plateOption = [...arr,...resData];
          // this.totalArticle = totalArticle;
          // this.totalReply = totalReply;
          console.log(this.plateOption)
        })
        .catch(error => {
          console.log(error);
        })
    },

  },
  created() {
    this.isShowEditRow = this.$store.state.isAdmin == '1';
  },
  mounted() {
    this.findData();
    this.getForumSection()
    this.getForumGategory()
  },
  unmounted() {
    window.removeEventListener("keydown", this.keydown, false);
  },
  computed: {
    getUserName() {
      return this.$store.state.userName;
    },
    getUserUID() {
      return this.$store.state.userID;
    },
    getUserEmail() {
      return this.$store.state.email;
    },

  }
})
</script>
<style src="../forum/css/antd.css"></style>
<style type="text/css">
td.vxe-body--column {
  vertical-align: middle;
}
</style>
